/**
 * Mobile navigation drawer (APP-001 §14, §25).
 *
 * Accessible sheet drawer. Radix Dialog handles focus trapping and restores
 * focus to the trigger on close. The trigger is a labeled IconButton so it is
 * operable by keyboard and announced by screen readers.
 */
import * as React from 'react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { IconButton } from '@/components/ui/icon-button';
import { Menu } from '@/components/icons';
import { BrandMark } from './BrandMark';
import { NavItemLink } from './NavLinks';
import { getPrimaryNav } from '@/config/navigation';
import { getAppLinks } from '@/config/links';

export function MobileNavigation() {
  const [open, setOpen] = React.useState(false);
  const sections = getPrimaryNav();
  const links = getAppLinks();

  return (
    <div className="lg:hidden">
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <IconButton label="Open navigation menu" variant="ghost">
            <Menu className="h-5 w-5" />
          </IconButton>
        </SheetTrigger>
        <SheetContent side="left" className="w-72 p-0">
          <div className="flex h-14 items-center border-b px-4">
            <a href={links.marketingBase} aria-label="Signup Risk home">
              <BrandMark />
            </a>
          </div>
          <nav className="overflow-y-auto p-3" aria-label="Mobile navigation">
            {sections.map((section) => (
              <div key={section.id} className="mb-4">
                <p className="px-3 pb-1 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                  {section.title}
                </p>
                <ul className="space-y-1">
                  {section.items.map((item) => (
                    <li key={item.to}>
                      <NavItemLink item={item} onNavigate={() => setOpen(false)} />
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>
        </SheetContent>
      </Sheet>
    </div>
  );
}
